import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import AdminPanel from './components/AdminPanel';
import MyTripsPage from './pages/MyTripsPage';
import TripViewPage from './pages/TripViewPage';
import CreateTripWizard from './components/CreateTripWizard/CreateTripWizard';
import OAuthCallback from './pages/OAuthCallback';
import { AuthProvider } from './contexts/AuthContext';
import './aws-config'; // Initialize Amplify

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-white">
          <Header />
          <main className="min-h-screen">
            <Routes>
              <Route path="/" element={<MyTripsPage />} />
              <Route path="/trips" element={<MyTripsPage />} />
              <Route path="/trips/:tripId" element={<TripViewPage />} />
              <Route path="/create-trip" element={<CreateTripWizard />} />
              <Route path="/oauth/callback" element={<OAuthCallback />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          {/* Admin Panel - Only shows on localhost */}
          <AdminPanel />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
